import { render, staticRenderFns } from "./AddSponsorDialogContent.vue?vue&type=template&id=4d48a9d0&scoped=true&"
import script from "./AddSponsorDialogContent.vue?vue&type=script&lang=js&"
export * from "./AddSponsorDialogContent.vue?vue&type=script&lang=js&"
import style0 from "./AddSponsorDialogContent.vue?vue&type=style&index=0&id=4d48a9d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d48a9d0",
  null
  
)

export default component.exports